import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthComponent} from './auth.component';
import {MatButtonModule, MatCardModule, MatCheckboxModule, MatInputModule, MatToolbarModule} from '@angular/material';
import {FormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        FormsModule,
        MatCardModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatButtonModule
    ],
    declarations: [AuthComponent]

})
export class AuthModule {
}
